<div style="margin-top: 30px; border: 1px solid #ccc; padding: 20px; border-radius: 8px;">
    <form [formGroup]="barcodeForm">
        <div class="form-row" *ngIf="saveStatus=='ADD'">
            <mat-form-field appearance="outline" style="width: 25%; margin-right: 3%;">
                <mat-label>Weight</mat-label>
                <input matInput formControlName="weight" placeholder="Enter weight in grams">
            </mat-form-field>

            <mat-form-field appearance="outline" style="width: 25%; margin-right: 3%;">
                <mat-label>Sender Mobile</mat-label>
                <input matInput formControlName="senderId" placeholder="Enter sender ID">
            </mat-form-field>
        </div>

        <div class="form-row">
            <mat-form-field appearance="outline" style="width: 79%;">
                <mat-label>Postal Codes</mat-label>
                <textarea matInput formControlName="postalCodes"
                    placeholder="Enter postal codes, comma separated"></textarea>
            </mat-form-field>
            <input type="file" (change)="onFileChange($event)" accept=".xlsx, .xls" style="margin-top: 10px;" />
        </div>
        
        <div class="form-row" style="margin-top: 10px;">
            <button mat-raised-button color="primary" (click)="getAddressLabelswithMobileNo()" style="margin-right: 14px;">
                Get Report
            </button>
            <button mat-raised-button color="danger" *ngIf="saveStatus!='ADD'" (click)="deleteBarcodesByBarcodeNumbers()" style="background-color: #f5365c;color:white;">
                Delete
            </button>
            <!-- <button mat-raised-button color="accent" style="margin-left: 10px;" (click)="exportToExcel()">
                Download Report
            </button> -->
        </div>
    </form>
</div>